
import { x24icloader } from '../../icons';

export default {
  name: 'Btn',
  components: {
    x24icloader,
  },
  props: {
    href: {
      type: String,
      default: '',
    },
    caps: {
      type: Boolean,
      default: false,
    },
    round: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'l',
      validator: (value) => {
        return ['s', 'm', 'l'].indexOf(value) !== -1;
      },
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary',
      validator: (value) => {
        return ['primary', 'secondary', 'white'].indexOf(value) !== -1;
      },
    },
    hoverColor: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'button',
    },
    delayForLoadingState: {
      type: Boolean,
    },
    delayForShowLoadingState: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      styles: {},
      mutableLoading: this.loading,
      mutableDisable: this.disable,
    };
  },
  computed: {
    sizeClass() {
      return this.size ? `btn_size-${this.size}` : '';
    },
    sizeRoundClass() {
      return this.size ? `btn_round_size-${this.size}` : '';
    },
    themeClass() {
      if (this.disable) {
        return `btn_${this.color} btn_${this.color}--disable`;
      }
      return `btn_${this.color}`;
    },
  },
  watch: {
    loading: {
      handler(value) {
        if (value && this.delayForLoadingState) {
          this.mutableLoading = false;
          this.mutableDisable = true;
          setTimeout(() => {
            this.mutableLoading = this.loading;
            this.mutableDisable = this.disable;
          }, this.delayForShowLoadingState);
        } else {
          this.mutableLoading = value;
        }
      },
      immediate: true,
    },
    delayForLoadingState: {
      handler(value) {
        if (value && this.mutableLoading) {
          this.mutableLoading = false;
          this.mutableDisable = true;
          setTimeout(() => {
            this.mutableLoading = true;
            this.mutableDisable = this.disable;
          }, this.delayForShowLoadingState);
        }
      },
      immediate: true,
    },
    disable: {
      handler(value) {
        this.mutableDisable = value;
      },
      immediate: true,
    },
  },
  methods: {
    onHover(event) {
      if (this.disable) return;
      this.styles['background-color'] = event.target.style['background-color'];
      if (this.hoverColor) {
        event.target.style.backgroundColor = this.hoverColor;
      }
    },
    onLeave(event) {
      if (this.disable) return;
      event.target.style.backgroundColor = this.styles['background-color'];
    },
  },
};
